import { useEffect } from 'react';
import { useAuthStore } from '../store/useAuthStore';

export function useSessionBootstrap(): { sessionLoading: boolean } {
  const bootstrapSession = useAuthStore((state) => state.bootstrapSession);
  const sessionLoading = useAuthStore((state) => state.sessionLoading);

  useEffect(() => {
    void bootstrapSession();
  }, [bootstrapSession]);

  return { sessionLoading };
}
